import { ShigoPermission } from '../../auth/permissions';

export function canEditDomainCompliance(can: (permission: ShigoPermission) => boolean) {
  return (
    can(ShigoPermission.DemandComplianceDpsEdit) || can(ShigoPermission.ComplianceDomainCreate)
  );
}
